/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class PackagesAPI extends ApiClient {
  constructor() {
    super('shipping/packages', { accountScoped: true, apiVersion: 'v1' });
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { package: data });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, { package: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new PackagesAPI();
